export const COUNTDOWN_TEXTS = [
  ["Okay", "Three", "Two", "One", "Let's Jam!"],
  [
    "Are you ready Steve?",
    "Mick? Andy?",
    "Alright fellahs...",
    "Lets GOOOOOOO!!",
  ],
  ["It's time-", "to DU-DU-DU", "DUEL!"],
  [
    "This is an art attack~",
    "THIS is an art attack!",
    "THIS IS...",
    "ART ATTACK!",
  ],
  ["One Fish", "Two Fish", "Red Fish", "YOU FISH"],
  [
    "Slam it to the left!",
    "Shake it the right!",
    "Chica's to the front!",
    "Hai, si, Ja! DRAW RIGHT!",
  ],
  ["H, O, T, T, O, G, O", "You can draw me..", "HOT TO GO!"],
  ["Snake?", "SNAKE?", "SNAAAAAAAAAAAKE!!"],
  ["It was a One-Eyed", "One-Horned, Flying", "Purple People Eater!"],
  [
    "Country roooads...",
    "Draw me hoooome...",
    "to the plaaaace...",
    "I beloooong...",
    "WEST VIRGINIA",
  ],
  ["One", "and a two", "and a three", "BA DUM DUM DUM"],
];
